// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"2410a54f","346":"ab82233d","595":"9fd1c7e8"}[chunkId] + ".chunk.css";
};